import React from 'react'
import RegisterGoogleDetail from '../common/GoogleOriginalDesign/Foodslabo/Detail/RegisterGoogleDetail'

export default function InsideSalesRegister() {
    return (
        <RegisterGoogleDetail
            reasonPoint1Images={[
                {
                    src: '/pages/inside_sales/reason_point1_img1.png',
                    alt: 'インサイドセールスの限定求人詳細1枚目',
                },
                {
                    src: '/pages/inside_sales/reason_point1_img2.png',
                    alt: 'インサイドセールスの限定求人詳細2枚目',
                },
                {
                    src: '/pages/inside_sales/reason_point1_img3.png',
                    alt: 'インサイドセールスの限定求人詳細3枚目',
                },
            ]}
            signupPath='signup?channel=inside_sales_register'
        />
    )
}
